module.exports = __webpack_public_path__ + "static/media/12.309b9599.svg";